<template>
  <v-container fluid>
    <v-container fluid class="pa-0">
      <v-card class="d-flex pa-0" flat tile outined>
        <v-card-text :class="c_bpheight">
          <v-row justify="center" dense>
            <v-col cols="4" sm="3" md="3">
              <v-select
                v-model="baseItems.search_option.value"
                :items="codeOpt.search_option"
                item-text="scode_name"
                item-value="scode"
                hide-details
                @change="(event) => onOptCodeChange('search_option', event)"
              ></v-select>
            </v-col>
            <v-col cols="8" sm="9" md="9">
              <v-text-field
                v-model="baseItems.search_data.value"
                label="찾기 "
                hide-details="auto"
                clearable
                clear-icon="mdi-close-circle"
              />
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col v-if="flagItem.dateflag" cols="6" sm="3" md="3">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="10"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="baseItems.start_reg_date.value"
                    label="작성일자(시작)"
                    readonly
                    v-bind="attrs"
                    hide-details="auto"
                    clear-icon="mdi-close-circle"
                    clearable
                    v-on="on"
                  >
                    <v-icon slot="prepend-inner" color="primary" small
                      >mdi-calendar-today</v-icon
                    >
                    <v-icon slot="clear" color="primary" small
                      >mdi-close-circle</v-icon
                    >
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="baseItems.start_reg_date.value"
                  no-title
                  @input="menu1 = false"
                />
              </v-menu>
            </v-col>

            <v-col v-if="flagItem.dateflag" cols="6" sm="3" md="3">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="-100"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="baseItems.end_reg_date.value"
                    label="작성일자(종료)"
                    prepend-inner-icon="mdi-calendar-today"
                    readonly
                    v-bind="attrs"
                    hide-details="auto"
                    clear-icon="mdi-close-circle"
                    clearable
                    v-on="on"
                  >
                    <v-icon slot="clear" color="primary" small
                      >mdi-close-circle</v-icon
                    >
                    <v-icon slot="prepend-inner" color="primary" small
                      >mdi-calendar-today</v-icon
                    >
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="baseItems.end_reg_date.value"
                  no-title
                  @input="menu2 = false"
                />
              </v-menu>
            </v-col>
            <v-col cols="4" sm="3" md="3" align-self="end">
              <v-card class="d-flex" flat tile>
                <v-menu v-if="$vuetify.breakpoint.mdAndDown" offset-y>
                  <template #activator="{ on, attrs }">
                    <v-btn color="primary" dark icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item v-for="(item, i) in dayItems" :key="i">
                      <v-list-item-title @click="onDayItems(item)">
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card>
            </v-col>
            <v-col cols="8" sm="3" md="3" align-self="end">
              <v-card class="d-flex justify-end" flat tile>
                <v-btn
                  small
                  color="primary"
                  class="mr-2"
                  outlined
                  @click="onSubmitFetch"
                >
                  조회
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  class="mr-2"
                  outlined
                  @click="newEditItem"
                >
                  글쓰기
                </v-btn>
                <v-btn
                  small
                  color="primary"
                  class="mr-2"
                  outlined
                  @click="onComfirmDelete"
                >
                  삭제
                </v-btn>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <v-container fluid class="grey lighten-5 pa-0">
      <v-row class="grey lighten-5">
        <v-col>
          <v-card outlined>
            <v-data-table
              v-model="selected"
              :mobile-breakpoint="0"
              :headers="headers"
              :items="desserts"
              :items-per-page="pageItem.pagePerRow"
              item-key="seq"
              :single-select="singleSelect"
              :value="selectedRows"
              checkbox-color="red"
              show-select
              hide-default-footer
              :sort-by="['reg_date', 'bor_name']"
              :sort-desc="[false, true]"
              multi-sort
              class="elevation-0"
              :item-class="(item) => item.class"
              @dblclick:row="onRowClicked"
            >
              <template #[`item.actions`]="{ item }">
                <v-icon class="mr-6" @click="editItem(item)">
                  mdi-pencil
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="grey lighten-5 pa-0">
      <v-row class="grey lighten-5 pb-2" no-gutters>
        <v-col cols="12">
          <v-card
            class="d-flex justify-start py-2"
            elevation="0"
            flat
            tile
            outlined
          >
            <v-row no-gutters dense>
              <v-spacer> </v-spacer>
              <v-col v-if="flagItem.chevronflag" cols="3" sm="3" md="2">
                <v-card class="d-flex justify-end mr-2" flat tile>
                  <v-btn
                    icon
                    @click="(event) => onOptCodeChange('StartPage', event)"
                  >
                    <v-icon>{{ "mdi-chevron-double-left" }}</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="(event) => onOptCodeChange('PrivPage', event)"
                  >
                    <v-icon>{{ "mdi-chevron-left" }}</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="(event) => onOptCodeChange('NextPage', event)"
                  >
                    <v-icon>{{ "mdi-chevron-right" }}</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    @click="(event) => onOptCodeChange('EndPage', event)"
                  >
                    <v-icon>{{ "mdi-chevron-double-right" }}</v-icon>
                  </v-btn>
                </v-card>
              </v-col>
              <v-col cols="1" sm="1" md="1">
                <v-text-field
                  v-model="pageItem.currentPage"
                  type="number"
                  dense
                  hide-details
                  min="1"
                  :max="pageItem.totalPage"
                  class="centered-input text--darken-3 mt-1"
                ></v-text-field>
              </v-col>
              <v-col cols="2" sm="2" md="1">
                <p class="text-left mt-2 ms-1">/ {{ pageItem.totalPage }}</p>
              </v-col>

              <v-col cols="2" sm="1" md="1">
                <p class="text-right mt-2 mr-3">줄수</p>
              </v-col>
              <v-col cols="2" sm="1" md="1">
                <v-select
                  v-model="optItems.pagePerRow"
                  class="text-right"
                  :items="codeOpt.pagePerRow"
                  item-text="scode_name"
                  item-value="scode"
                  dense
                  hide-details
                  return-object
                  @change="(event) => onOptCodeChange('pagePerRow', event)"
                ></v-select>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="snackbar.snackbar"
      :timeout="snackbar.timeout"
      :multi-line="snackbar.multiLine"
    >
      {{ snackbar.text }}

      <template #action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <dialog-board-page
      :props-option="propsOption"
      :props-data="propsData"
      @prop-return="onsetPropReturn"
    />
    <dialog-message-eBus />
  </v-container>
</template>

<script>
import EventBus from "../EventBus";
import DialogMessageEBus from "./dialogMessageEBus";
import dialogBoardPage from "./dialogBoardAA.vue";

import { mapActions, mapGetters } from "vuex"; // mapGetters를 추가한다

const board = "board";
const register = "register";
const metaCode = "metaCode";

export default {
  name: "BoardPage",
  components: { dialogBoardPage, DialogMessageEBus },
  props: {
    payload: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      message: { Type: "", Head: "", Message: "" },

      dayItems: [
        { title: "당일", click: "on0Day" },
        { title: "3일", click: "on3Day" },
        { title: "1주일", click: "on1Week" },
        { title: "1달", click: "on1Month" },
      ],
      dayCloseOnClick: true,

      search: "",
      singleSelect: false,
      selectedRows: [],
      selected: [],
      desserts: [],
      headers: [
        {
          text: "제목",
          value: "bor_name",
          width: "200px",
          class: "primary",
          align: "left",
        },
        {
          text: "생성자",
          value: "reg_id",
          width: "150px",
          class: "primary",
          align: "center",
        },
        {
          text: "생성일자",
          value: "reg_date",
          width: "150px",
          class: "primary",
          align: "center",
        },
        {
          text: "첨부여부",
          value: "bor_file_status",
          width: "100px",
          class: "primary",
          align: "center",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "150px",
          class: "primary",
          align: "center",
        },
      ],

      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      flagItem: {
        dateflag: true,
        chevronflag: true,
      },
      optItems: { pagePerRow: [], search_option: [] },
      codeOpt: {
        pagePerRow: [5, 10, 20, 50, 100, 200, 300, 500],
        search_option: [],
      },

      codeStore: {},
      pageItem: {
        totalRow: 0,
        totalPage: 0,
        currentPage: 0,
        pagePerRow: 10,
      },
      editorData: "",
      editorConfig: {},
      menu1: false,
      menu2: false,
      mstart_date: "",
      mend_date: "",
      currentRow: 0,
      maxRow: 0,

      fun_code: "",
      baseItems: {
        search_data: { value: "", readonly: true, clearable: false },
        search_option: { value: "", readonly: true, clearable: false },
        start_reg_date: { value: "", readonly: true, clearable: false },
        end_reg_date: { value: "", readonly: true, clearable: false },
        bor_part: { value: "board", readonly: true, clearable: false },
        bor_key: { value: "", readonly: true, clearable: false },
        bor_name: { value: "", readonly: true, clearable: false },
        bor_details: { value: "", readonly: true, clearable: false },
        bor_file_status: { value: "", readonly: true, clearable: false },
        status: { value: "00", readonly: true, clearable: false },
      },
      propsOption: "0000",
      propsData: {
        option: "0000",
        dialogBoard: {},
        DialogResult: {},
      },
      snackbar: {
        snackbar: false,
        text: `Hello, I'm a snackbar`,
        multiLine: true,
        timeout: 2000,
      },

      defaultButtonText: "파일업로드",
      selectedFile: null,
      isSelecting: false,

      dialogDelete: false,
      borPartValue: "board",
    };
  },
  computed: {
    ...mapGetters(register, {
      userID: "getUid",
    }),
    // ...mapGetters(board, {
    //   Litems: "GE_BOARD_CALENDAR",
    // }),
    // ...mapGetters(metaCode, {
    //   statusItems: "GE_STATUSCODE",
    // }),
    // buttonText() {
    //   return this.selectedFile
    //     ? this.selectedFile.name
    //     : this.defaultButtonText;
    // },

    c_bpheight() {
      return "text - " + this.$vuetify.breakpoint.height + "- subtitle";
    },
  },

  created() {
    EventBus.$off("push-confirm");
    EventBus.$on("push-confirm", (param) => {
      //console.log("push-confirm ", param);
      this.oninitConfirm(param);
    });

    this.onReset(false);

    this.oninitMeteCode();
    //   if (this.$route.params.rowid) {
    //     this.editItem(this.$route.params.rowid);
    //   }
    //   console.log("params", this.$route.params.rowid);
  },
  methods: {
    ...mapActions(board, ["BOARD_A"]),
    ...mapActions(metaCode, ["SYSCODE"]),

    async onSubmitFetch() {
      this.maxRow = 0;
      this.baseItems.status.value = "00";
      try {
        const boardResult = await this.BOARD_A({
          fun_code: "boardaFetch",
          bor_part: this.baseItems.bor_part.value,
          start_reg_date: this.baseItems.start_reg_date.value,
          end_reg_date: this.baseItems.end_reg_date.value,
          search_data: this.baseItems.search_data.value,
          search_option: this.baseItems.search_option.value,
          status: this.baseItems.status.value,
          page_number: parseInt(this.pageItem.currentPage) + 0,
          page_rows: parseInt(this.pageItem.pagePerRow) + 0,
        });
        console.log("boardResult", boardResult);
        if (boardResult) {
          this.pageItem.totalRow = boardResult.data.repData[0].total_row_count;
          this.pageItem.totalPage = Math.ceil(
            this.pageItem.totalRow / this.pageItem.pagePerRow
          );
          if (this.pageItem.totalPage > 0 && this.pageItem.currentPage === 0) {
            this.pageItem.currentPage = 1;
          }
          const events = [];
          let ii = 0;
          let rowColor = "";
          if (this.pageItem.totalRow > 0) {
            for (let eventData of boardResult.data.repDatas) {
              ii = ii + 1;
              // if (ii % 2) {
              //   rowColor = "grey lighten-2";
              // } else {
              //   rowColor = "transparent";
              // }
              events.push({
                seq: eventData.seq,
                bor_part: eventData.bor_part,
                bor_key: eventData.bor_key,
                bor_file_status: eventData.bor_file_status,
                bor_name: eventData.bor_name,
                bor_details: eventData.bor_details,
                status: eventData.status,
                reg_id: eventData.reg_id,
                reg_date: eventData.reg_date,
                reg_time: eventData.reg_time,
                class: rowColor,
              });
              ++this.maxRow;
            }
          }
          this.desserts = events;
          --this.maxRow;
          console.log(this.desserts);
          this.onReset(true);
        }
      } catch (err) {
        this.message.Head = "Error";
        this.message.Message = err;
        this.onMessageDisplay();
        console.error(err);
      }
    },
    async onSubmitSave() {
      console.log("onSubmitSave", this.baseItems);
      try {
        const boardResult = await this.BOARD_A({
          fun_code: this.fun_code,
          bor_part: this.baseItems.bor_part.value,
          bor_key: this.baseItems.bor_key.value,
          bor_name: this.baseItems.bor_name.value,
          bor_details: this.baseItems.bor_details.value,
          bor_file_status: this.baseItems.bor_file_status.value,
          status: this.baseItems.status.value,
          reg_id: this.userID,
          chg_id: this.userID,
        });
        console.log("boardResult", boardResult);
        if (boardResult.data.repCode === "00") {
          let para = {
            propsOption: "0005",
            message: "삭제 되었습니다.",
          };
          this.onsetPropReturn(para);
        }

        // this.message.Message = boardResult.data.repMessage;
        // this.onMessageDisplay();
      } catch (err) {
        this.message.Head = "Error";
        this.message.Message = err;
        this.onMessageDisplay();
        console.error(err);
      }
    },
    onSubmitDelete() {
      this.fun_code = "boardaSetDelete";
      if (0 < this.selected.length) {
        this.selected.forEach((row) => {
          this.baseItems.bor_part.value = row.bor_part;
          this.baseItems.bor_key.value = row.bor_key;
          this.baseItems.status.value = "09";
          const index = this.desserts.indexOf(row);
          this.desserts.splice(index, 1);
          if (row.bor_key) {
            console.log("Deleted", row);
            this.onSubmitSave();
          }
        });
      }
      this.selected = [];
      this.onSubmitFetch();
    },

    onComfirmDelete() {
      let param = {
        pushDivision: "delete",
        Head: "삭제 확인",
        Message: " ",
      };
      EventBus.$emit("push-delete", param);
    },

    onNewClicked() {
      this.fun_code = "boardaInsert";
      this.onReset(false);
    },
    onRowClicked(event, { item }) {
      this.fun_code = "boardaUpdate";
      this.onReset(true);
      this.baseItems.bor_part.value = item.bor_part;
      this.baseItems.bor_key.value = item.bor_key;
      this.baseItems.bor_name.value = item.bor_name;
      this.baseItems.bor_details.value = item.bor_details;
      this.baseItems.bor_file_status.value = item.bor_file_status;
      this.editorData = item.bor_details;
      this.currentRow = item.seq;
      this.editItem(item);
      console.log("onRowClicked : ", item);
    },

    onMessageDisplay() {
      let payload = {
        Type: this.message.Type,
        Head: this.message.Head,
        Message: this.message.Message,
        dialog: true,
      };
      this.$emit("tabs-msg", payload);
      console.log("onMessageDisplay", payload);
    },

    async onOptCodeChange(opt, event) {
      let tempCODE = "";
      if (event == null) {
        tempCODE = "";
      } else {
        tempCODE = event.scode;
      }
      switch (opt) {
        case "search_option":
          this.baseItems.search_option.value = event;
          break;
        case "pagePerRow":
          if (event == null) {
            this.pageItem.pagePerRow = "5";
          } else {
            this.pageItem.pagePerRow = parseInt(event.scode_name);
            this.pageItem.currentPage = 0;

            this.onSubmitFetch();
          }
          break;
        case "NextPage":
          if (this.pageItem.currentPage === this.pageItem.totalPage) {
            return;
          }
          this.pageItem.currentPage++;
          this.onSubmitFetch();
          break;

        case "PrivPage":
          if (this.pageItem.currentPage <= 1) {
            return;
          }
          this.pageItem.currentPage--;
          this.onSubmitFetch();
          break;

        case "StartPage":
          this.pageItem.currentPage = 1;
          this.onSubmitFetch();
          break;

        case "EndPage":
          this.pageItem.currentPage = this.pageItem.totalPage;
          this.onSubmitFetch();
          break;

        default:
      }
      console.log("onCodeChange", opt, event);
    },

    async oninitMeteCode() {
      const [search_option, pagePerRow] = await Promise.all([
        this.oninitSysCode("S000000002"),
        this.oninitSysCode("S000000003"),
      ]);

      this.codeOpt.search_option = search_option;
      this.codeOpt.pagePerRow = pagePerRow;
      this.pageItem.pagePerRow = parseInt(pagePerRow[0].scode_name);
      this.optItems.pagePerRow = pagePerRow[0].scode;

      this.baseItems.search_option.value = search_option[0].scode;
    },
    async oninitSysCode(sysCode) {
      console.log("oninitSysCode", sysCode);
      try {
        const sysResult = await this.SYSCODE({
          fun_code: "sysCodeMapFetch",
          sys_id: sysCode,
        });
        console.log("oninitSysCode", sysResult.data.repDatas);
        return sysResult.data.repDatas;
      } catch (err) {
        console.error(err);
      }
    },
    onReset() {
      this.baseItems.bor_part.value = "board";
      this.baseItems.bor_key.value = "";
      this.baseItems.bor_name.value = "";
      this.baseItems.bor_details.value = "";
      this.baseItems.bor_file_status.value = "";
      this.baseItems.status.value = "00";
      this.editorData = this.baseItems.bor_details.value;
    },

    onFileChanged(e) {
      this.selectedFile = e.target.files[0];
      console.log("onFileChanged", this.selectedFile);
    },

    newEditItem() {
      this.onReset();
      this.propsOption = "0001";
      this.propsData.option = "0001";
      this.propsData.dialogBoard.dialog = true;

      this.propsData.dialogBoard.bor_part = this.baseItems.bor_part.value;
      this.propsData.dialogBoard.bor_key = this.baseItems.bor_key.value;
      this.propsData.dialogBoard.status = this.baseItems.status.value;
    },

    editItem(item) {
      this.propsOption = "0003";
      this.propsData.option = "0003";
      this.propsData.dialogBoard.dialog = true;

      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.propsData.dialogBoard.item = item;
      console.log("editItem", item);
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      console.log("deleteItem", item);
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },
    oninitConfirm(value) {
      if (value.result === "00") {
        switch (value.pushDivision) {
          case "insert": {
            this.fun_code = "clientInfoInsert";
            this.onSubmitSave();
            break;
          }
          case "update": {
            this.fun_code = "clientInfoUpdate";
            this.onSubmitSave();
            break;
          }
          case "delete": {
            this.onSubmitDelete();
            break;
          }
          case "condition": {
            this.onNewClicke();

            break;
          }
          default:
        }
      }

      console.log("oninitConfirm", value);
    },

    onsetPropReturn(para) {
      if (para.propsOption === "0005") {
        this.onSubmitFetch();

        this.snackbar.text = para.message;
        this.snackbar.snackbar = true;
      }
      this.propsOption = "0000";
      console.log("onsetPropReturn", para);
    },
    onDayItems(item) {
      console.log("onDayItems", item.click);
      const today = new Date();
      let addDay = new Date();
      console.log(" new today : ", today);
      switch (item.click) {
        case "on0Day": {
          addDay = this.nextDate(today, 0, 0);
          break;
        }
        case "on3Day": {
          addDay = this.nextDate(today, -3, 0);
          break;
        }
        case "on1Week": {
          addDay = this.nextDate(today, -7, 0);
          break;
        }
        case "on1Month": {
          addDay = this.nextDate(today, 0, -1);
          break;
        }
        default:
          addDay = this.nextDate(today, -3, 0);
      }
      this.baseItems.end_reg_date.value = this.format_date(today);
      this.baseItems.start_reg_date.value = this.format_date(addDay);
    },
    format_date(today) {
      if (today) {
        return (
          "" +
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1 > 9 ? "" : "0") +
          (today.getMonth() + 1) +
          "-" +
          (today.getDate() > 9 ? "" : "0") +
          today.getDate()
        );
      }
    },
    nextDate(date, days, month) {
      const clone = new Date(date);
      clone.setMonth(date.getMonth() + month);
      clone.setDate(date.getDate() + days);
      return clone;
    },
  },
};
</script>

<style scoped>
.row td {
  cursor: pointer;
}
.dataTable {
  font-size: 16px !important;
}
table.v-table thead th {
  font-size: 16px;
}
/* also tried table.v-table thead tr th { . */
table.v-table tbody tr td {
  font-size: 16px;
  height: 15px;
  padding: 0px;
}
.v-data-table header {
  font-size: 16px;
}

.v-data-table th {
  font-size: 16px;
}

.v-data-table td {
  font-size: 16px;
}
.v-data-table .v-data-table-header tr th {
  font-size: 24px !important;
}
</style>
